module.exports = __webpack_public_path__ + "media/images/WFC_Award_Black-b71e5629511dad79c606fc8790f2a8a4.svg";